// voice: Bunny (af_heart), Player (male: am_fenrir, female: af_jessica)

const MEDIA_BASE_URL =
  process.env.REACT_APP_MEDIA_BASE_URL ||
  "https://example.com/iseeabunny";
// **Bunny:** Oh, hello there! I didn't see you.
// **Player:** Hi! What are you doing with that notebook?
// **Bunny:** This is my special notebook! It has all the fun pictures and words I'm trying to learn.
// **Player:** Wow, it looks amazing! But... do you know what all the words mean?
// **Bunny:** Not all of them. I love learning words, but some are tricky! I really want to learn more so I can read cool stories, explore exciting places, and make lots of friends.
// **Player:** That sounds like a great dream! Maybe... I could help you?
// **Bunny:** Really? You'd teach me new words? That would be so wonderful! We could be a team!
// **Player:** Absolutely! Let's start filling your notebook with all kinds of exciting words.
// **Bunny:** Yay! I can't wait to learn with you. Let's get started right away!

export const INTRO_CONTENT = {
  images: [
    `${MEDIA_BASE_URL}/gen-images/bunny-intro-01.jpeg`,
    `${MEDIA_BASE_URL}/gen-images/bunny-intro-02.jpeg`,
    `${MEDIA_BASE_URL}/gen-images/bunny-intro-03.jpeg`,
    `${MEDIA_BASE_URL}/gen-images/bunny-intro-04.jpeg`,
  ],
  dialogs: [
    {
      type: "student",
      audioUrl: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-01.mp3`,
      imageIndex: 0,
    },
    {
      type: "teacher",
      audioUrl: {
        male: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-02.mp3`,
        female: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-03.mp3`,
      },
      imageIndex: 0,
    },
    {
      type: "student",
      audioUrl: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-04.mp3`,
      imageIndex: 1,
    },
    {
      type: "teacher",
      audioUrl: {
        male: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-05.mp3`,
        female: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-06.mp3`,
      },
      imageIndex: 1,
    },
    {
      type: "student",
      audioUrl: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-07.mp3`,
      imageIndex: 2,
    },
    {
      type: "teacher",
      audioUrl: {
        male: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-08.mp3`,
        female: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-09.mp3`,
      },
      imageIndex: 2,
    },
    {
      type: "student",
      audioUrl: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-10.mp3`,
      imageIndex: 3,
    },
    {
      type: "teacher",
      audioUrl: {
        male: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-11.mp3`,
        female: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-12.mp3`,
      },
      imageIndex: 3,
    },
    {
      type: "student",
      audioUrl: `${MEDIA_BASE_URL}/gen-audio/bunny-intro-13.mp3`,
      imageIndex: 3,
    },
  ],
};
